(function (scope) {
  'use strict';
  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));
  function dimensions(value) {
    const match = String(value || '').match(/^(\d+(?:\.\d+)?(?:\s+\d+\/\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?(?:\s+\d+\/\d+)?)/i);
    const number = text => text.split(/\s+/).reduce((sum, part) => sum + (part.includes('/') ? Number(part.split('/')[0]) / Number(part.split('/')[1]) : Number(part)), 0);
    return match ? { width: number(match[1]), height: number(match[2]) } : null;
  }
  function eligible(variant) {
    const d = dimensions(variant.size);
    return Boolean(d && variant.physical !== false && Math.min(d.width, d.height) >= 24 && d.width * d.height >= 720);
  }
  function orientation(variant) {
    const d = dimensions(variant.size);
    return !d ? '' : d.width === d.height ? 'square' : d.width > d.height ? 'horizontal' : 'vertical';
  }
  function groupArtworks(products) {
    const groups = new Map();
    for (const product of products) {
      const title = product.title.replace(/\s*\|\s*(?:XL|Slimwoods) Framed Canvas$/i, '').trim();
      const key = title.toLowerCase().replace(/\s+/g, ' ');
      if (!groups.has(key)) groups.set(key, { ...product, title, sourceProductIds: [], variants: [] });
      const group = groups.get(key);
      group.sourceProductIds.push(product.id);
      // A single artwork can span multiple Shopify listings. Keep each variant's
      // owning URL for product details and the pre-cart price/availability check.
      for (const variant of product.variants) {
        if (!group.variants.some(v => v.id === variant.id)) group.variants.push({ ...variant, productId: product.id, productUrl: product.url });
      }
    }
    for (const group of groups.values()) group.variants.sort((a, b) => {
      const x = dimensions(a.size), y = dimensions(b.size);
      return x.width * x.height - y.width * y.height;
    });
    return [...groups.values()];
  }
  function fitRect(x, y, width, ratio, roomRatio) {
    width = clamp(width, .035, Math.min(.9, .9 * ratio / roomRatio));
    const height = width * roomRatio / ratio;
    return { x: clamp(x, width / 2, 1 - width / 2), y: clamp(y, height / 2, 1 - height / 2), width, height };
  }
  function cartBody(id, path) {
    if (!/^\d+$/.test(String(id))) throw new Error('Invalid variant');
    return { items: [{ id: Number(id), quantity: 1 }], sections: ['cart-drawer', 'cart-bubble'], sections_url: path };
  }
  function fixedRect(x, y, width, ratio, roomRatio) {
    const height = width * roomRatio / ratio;
    return {x:width >= 1 ? .5 : clamp(x,width/2,1-width/2),y:height >= 1 ? .5 : clamp(y,height/2,1-height/2),width,height};
  }
  const sceneReferences = {
    alcove:{inches:144,fraction:1},
    living:{inches:108,fraction:1},fireplace:{inches:60,fraction:.37},
    // Modeled furniture widths in the generated scenes; not surveyed dimensions.
    // Use horizontal spans to avoid the floor-depth distortion of leg heights.
    entry:{inches:108,fraction:.71},
    dining:{inches:120,fraction:.86},
    bedroom:{inches:80,fraction:.43},reflection:{inches:36,fraction:.33},piano:{inches:64,fraction:.404}
  };
  const api = { clamp, dimensions, eligible, orientation, groupArtworks, fitRect, fixedRect, sceneReferences, cartBody };
  scope.StatementCore = api;
  if (typeof module !== 'undefined') module.exports = api;
})(typeof window === 'undefined' ? globalThis : window);
